module.exports = __webpack_public_path__ + "img/IMG-20200911-WA0005.3bcd45e3.jpg";